import * as APIConstants from 'constants/apiConstants';
import { get, post, put } from 'utils/httpHelpers';

const apiVersion = APIConstants.version.V3;

export const getRenewalDetails = async (oneMonthFreeSearchParam) => get(APIConstants.API_RENEWAL_DATA, oneMonthFreeSearchParam ? { [APIConstants.URL_PARAMETERS.ONE_MONTH_FREE]: true } : null, null, false, apiVersion);

export const releaseLockToken = async (token) => post(APIConstants.API_RENEWAL_RELEASE_LOCK, null, null, token, false, apiVersion);

// Used in MyRACService.js and will remain there this is just a placeholder until further endpoints are added
export const getEligibility = async () => get(APIConstants.API_RENEWAL_ELIGIBILITY, null, null, false, apiVersion);

export const getPaymentIdAndLockToken = async (payload) => post(APIConstants.API_RENEWAL_CREATE_PAYMENT_ID, null, null, payload, false, apiVersion);

export const setCardPayment = async (payload) => put(APIConstants.API_RENEWAL_PAYMENT_STATUS, null, null, payload, false, apiVersion);

export const getCardPaymentStatus = async (paymentId) => get(APIConstants.API_PRODUCT_PAYMENT_STATUS(paymentId), null, null, false);

export const setDirectDebit = async (payload, monthlyFlex) => {
  // Monthly flex must use endpoint that will only validate direct debit data
  const url = monthlyFlex
    ? APIConstants.API_RENEWAL_DIRECT_VALIDATE_ONLY
    : APIConstants.API_RENEWAL_DIRECT_DEBIT_STATUS;

  return put(url, null, null, payload, false, apiVersion);
};
